import palette from 'theme/palette'

const MuiTextField = {
  root: {
    color: palette.text.primary,
  },
}

export default MuiTextField
